import { Button, Heading, Stack, Text, VStack } from "@chakra-ui/react";
import * as React from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import { joinWorkspace } from "../api/workspace";
import LoginShell from "../components/login-shell";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  checkUser,
  setReturnLocation,
  setSignupWithoutWorkspace,
  setUser,
} from "../store/authSlice";

export default function JoinWorkspacePage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useAppSelector((s) => s.auth);
  const { id, token } = useParams();
  const [isLoading, setIsLoading] = React.useState(false);
  const here = React.useMemo(() => {
    return `/join-workspace/${id}/${token}`;
  }, [id, token]);
  const join = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const workspaceId = Number(id);
      await joinWorkspace(workspaceId, token);
      const { workspaces } = await dispatch(checkUser()).unwrap();
      const workspace = workspaces.find((w) => w.id === workspaceId);
      if (workspace) navigate(`/workspaces/${workspace.slug}`);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, id, navigate, token]);
  const useAnotherAccount = React.useCallback(() => {
    dispatch(setUser(null));
  }, [dispatch]);
  React.useEffect(() => {
    if (user === null) {
      dispatch(setReturnLocation(here));
      dispatch(setSignupWithoutWorkspace(true));
    }
  }, [dispatch, here, user]);
  if (user === null) {
    return <Navigate to="/login" />;
  }

  return (
    <LoginShell>
      <Stack color="fg.accent" gap={{ base: "2", md: "3" }} textAlign="center">
        <Heading size={{ base: "2xl", md: "3xl" }}>Join Workspace</Heading>
      </Stack>
      <VStack>
        <Text>Join this workspace as {user.username}?</Text>
        <Button
          colorScheme="purple"
          width="full"
          onClick={join}
          disabled={isLoading}
        >
          Join
        </Button>
        <Button width="full" onClick={useAnotherAccount}>
          Use another account
        </Button>
      </VStack>
    </LoginShell>
  );
}
